import candidatesActions from "./actions";

const initialState = {
  instructionRead: {},
  isActiveTabLoaded: false,
  isInstructionReadLoaded: false,
  paymentConfirmationLoaded: false,
  isPgp:false,
  editingFacilityAmount:null,
  instructionStatus:false,
   status: null,
  showImage: null,
  editingFormData:null,
  showCompressedImage: null,
  showSignature: null,
  showCompressedSignature: null,
  scribeDetailsLoaded: false,
  personalDetails: [],
  addressDetails: [],
  categoryDetails: [],
  educationDetails: [],
  examDetails: [],
  certificateDetails: [],
  queryByCanidate: [],
  otherDetails: [],
  uploadDetails: [],
  isUploadDetailsLoaded: false,
  courseUploadDetails: [],
  pincode: [],
  pincodeCorrespondence: [],
  courseActiveTab: [],
  FullCandidateDetails: [],
  courseFullRegistrationDetails: [],
  courseAddressDetails: [],
  courseList: {
    all: [],
    filtered: []
  },
  courseTabs: [],
  masterFields: [],
  applicantid: {},
  courseStatus: [],
  ispaid: [],
  paymentReceiptList: [],
  examState: [],
  examDistrict: {
    all: [],
    filtered: [],
  },
  examLanguage: [],
  courseFormDetails: [],
  currentCourseDetails: [],
  ipAddress: [],
  otbsVenueDetails: {
    States: [],
    Districts: [],
    Venues: []
  },
  currentOtbsVenue: [],
  getcourseCandidateDetail: [],
  getEligibilityDetail: [],
  admitcardurl: [],
  admitCardDownloadDetails: null,
  scoreCardDownloadDetails: null,
  bypassRegistrationData: [],
  isAirpay: [],
  isBilldesk:[],
  ispaymentLoading: false,
  totalFee: 0,

  coursePersonalInformationDetails: [],
  courseReservationDetails: [],
  courseReservationDetailsLoaded: false,
  courseAcademicDetails: [],
  courseAcademicDetailsLoaded: false,
  courseExamCenterDetails: [],
  courseExamCenterDetailsLoaded: false,
  courseEditingFacilityDetails: [],
  coursePaymentInformationDetails: [],
  candidateScribeDetails: [],
  scribeDetails: [],
  scribe1PhotoDetails: [],
  scribe1DocDetails: [],
  scribe2PhotoDetails: [],
  scribe2DocDetails: [],
  scribe1QualifyDetails: [],
  scribe2QualifyDetails: [],
  callBackApiCalled: {},
  candidateNameForEditing: null,
  candidateDobForEditing: null,
  candidateGenderForEditing: null,
  candidateGroupForEditing:null,
  pcm_noofattemptsediting:null,
  pcb_noofattemptsediting:null,
  noofattemptsediting:null,
  englishmediumediting:null,
  otbsSeatAvailibility: null,
  otbsSeatAvailibilityLoaded: null,
  showPcbFirstAttempt: true,
  showPcmFirstAttempt:true,
  shownoofattemptfirstattempt :true,
  shownooptionforenglishmedium: true,
  shownooptionforelct:true,
  gelctediting: null,
  isEditingFacilityDetailsLoaded:false,
  pcmpcbDetails: null,
};

const candidatesReducer = (state = initialState, action) => {
  switch (action.type) {
    case candidatesActions.SHOW_IMAGE:
      return {
        ...state,
        showImage: action.payload,
      };
      case candidatesActions.SHOW_PCB_FIRST_ATTEMPT:
      return {
        ...state,
        showPcbFirstAttempt: action.payload,
      };
      case candidatesActions.SHOW_NO_OF_FIRST_ATTEMPT:
      return {
        ...state,
        shownoofattemptfirstattempt: action.payload,
      };
            case candidatesActions.SHOW_NO_OPTION_FOR_ENGLISH_MEDIUM:
      return {
        ...state,
        shownooptionforenglishmedium: action.payload,
      };
             case candidatesActions.SET_PCM_PCB_DETAILS:
      return {
        ...state,
        pcmpcbDetails: action.payload,
      };
      case candidatesActions.SHOW_NO_OPTION_FOR_ELCT:
      return {
        ...state,
        shownooptionforelct: action.payload,
      };
      case candidatesActions.SHOW_PCM_FIRST_ATTEMPT:
      return {
        ...state,
        showPcmFirstAttempt: action.payload,
      };
    case candidatesActions.SHOW_COMPRESSED_IMAGE:
      return {
        ...state,
        showCompressedImage: action.payload,
      };
    case candidatesActions.IS_PGP:
      return {
        ...state,
        isPgp: action.payload,
      };
    case candidatesActions.SET_STATUS:
      return {
        ...state,
        status: action.payload,
      };
      case candidatesActions.SET_CANDIDATE_NAME_FOR_EDITING:
      return {
        ...state,
         candidateNameForEditing: action.payload,
      };
      case candidatesActions.SET_PCM_NO_OF_ATTEMPTS_FOR_EDITING:
      return {
        ...state,
         pcm_noofattemptsediting: action.payload,
      };
      case candidatesActions.SET_CANDIDATE_PCB_NO_OF_ATTEMPTS_FOR_EDITING:
      return {
        ...state,
         pcb_noofattemptsediting: action.payload,
      };
            case candidatesActions.SET_NO_OF_ATTEMPTS_EDITING:
      return {
        ...state,
         noofattemptsediting: action.payload,
      };
                  case candidatesActions.SET_ENG_MEDIUM_EDITING:
      return {
        ...state,
         englishmediumediting: action.payload,
      };
            case candidatesActions.SET_ELCT:
      return {
        ...state,
         gelctediting: action.payload,
      };
      case candidatesActions.SET_CANDIDATE_DOB_FOR_EDITING:
      return {
        ...state,
         candidateDobForEditing: action.payload,
      };
      case candidatesActions.SET_CANDIDATE_GENDER_FOR_EDITING:
      return {
        ...state,
         candidateGenderForEditing: action.payload,
      };
      case candidatesActions.SET_CANDIDATE_GROUP:
      return {
        ...state,
         candidateGroupForEditing: action.payload,
      };
    case candidatesActions.SHOW_SIGNATURE:
      return {
        ...state,
        showSignature: action.payload,
      };
    case candidatesActions.SHOW_INSTRUCTION:
      return {
        ...state,
        instructionStatus: action.payload,
      };
    case candidatesActions.SHOW_COMPRESSED_SIGNATURE:
      return {
        ...state,
        showCompressedSignature: action.payload,
      };

          case candidatesActions.SET_FORM_DATA:
      return {
        ...state,
        editingFormData: action.payload,
      };
      case candidatesActions.SET_EDITING_AMOUNT:
      return {
        ...state,
        editingFacilityAmount: action.payload,
      };

    case candidatesActions.SET_PROFILE_PERSONAL_DETAILS:
      return {
        ...state,
        personalDetails: action.payload,
      };
    case candidatesActions.SET_CANDIDATE_SCRIBE_DETAILS:
      return {
        ...state,
        candidateScribeDetails: action.payload,
      };
    case candidatesActions.SET_ADDRESS_PERSONAL_DETAILS:
      return {
        ...state,
        addressDetails: action.payload,
      };
    case candidatesActions.SET_CATEGORY_PERSONAL_DETAILS:
      return {
        ...state,
        categoryDetails: action.payload,
      };
    case candidatesActions.SET_EDUCATION_PERSONAL_DETAILS:
      return {
        ...state,
        educationDetails: action.payload,
      };
    case candidatesActions.SET_EXAM_PERSONAL_DETAILS:
      return {
        ...state,
        examDetails: action.payload,
      };
          case candidatesActions.SET_SEAT_AVAILIBILITY:
      return {
        ...state,
        otbsSeatAvailibility: action.payload,
        otbsSeatAvailibilityLoaded: true
      };
    case candidatesActions.SET_CERTIFICATE_PERSONAL_DETAILS:
      return {
        ...state,
        certificateDetails: action.payload,
      };
    case candidatesActions.SET_QUERY_STATUS_BY_CANDIDATEID:
      return {
        ...state,
        queryByCanidate: action.payload,
      };
    case candidatesActions.SET_OTHER_PERSONAL_DETAILS:
      return {
        ...state,
        otherDetails: action.payload,
      };
    case candidatesActions.SET_UPLOAD_PERSONAL_DETAILS:
      return {
        ...state,
        uploadDetails: action.payload,
        isUploadDetailsLoaded: true,
      };
    case candidatesActions.SET_COURSE_UPLOAD_PERSONAL_DETAILS:
      return {
        ...state,
        courseUploadDetails: action.payload,
      };
    case candidatesActions.SET_PINCODE:
      return {
        ...state,
        pincode: action.payload,
      };
    case candidatesActions.SET_PINCODE_CORRESPONDENCE:
      return {
        ...state,
        pincodeCorrespondence: action.payload,
      };
    case candidatesActions.SET_FULL_CANDIDATE_DETAILS:
      return {
        ...state,
        FullCandidateDetails: action.payload,
      };
    case candidatesActions.SET_IS_INSTRUCTION_READ:
      return {
        ...state,
        instructionRead: {
          ...state.instructionRead,
          [action.courseId]: action.payload,
        },
        isInstructionReadLoaded: true,
      };
    case candidatesActions.SET_COURSE_REGISTRATION_DETAILS:
      return {
        ...state,
        courseFullRegistrationDetails: action.payload,
      };
    case candidatesActions.SET_COURSE_ADDRESS_DETAILS:
      return {
        ...state,
        courseAddressDetails: action.payload,
      };

    case candidatesActions.SET_ALL_COURSE_LIST:
      return {
        ...state,
        courseList: action.payload,
      };
    case candidatesActions.SET_SCRIBE1_PHOTO_DETAILS:
      return {
        ...state,
        scribe1PhotoDetails: action.payload,
      };
    case candidatesActions.SET_SCRIBE1_DOC_DETAILS:
      return {
        ...state,
        scribe1DocDetails: action.payload,
      };
    case candidatesActions.SET_SCRIBE2_DOC_DETAILS:
      return {
        ...state,
        scribe2DocDetails: action.payload,
      };
    case candidatesActions.SET_SCRIBE2_PHOTO_DETAILS:
      return {
        ...state,
        scribe2PhotoDetails: action.payload,
      };
    case candidatesActions.SET_SCRIBE1_QUALIFY_DOC_DETAILS:
      return {
        ...state,
        scribe1QualifyDetails: action.payload,
      };
    case candidatesActions.SET_SCRIBE2_QUALIFY_DOC_DETAILS:
      return {
        ...state,
        scribe2QualifyDetails: action.payload,
      };
    case candidatesActions.SET_SCRIBE_DETAILS:
      return {
        ...state,
        scribeDetails: action.payload,
        scribeDetailsLoaded: true,
        // callBackApiCalled: true
        callBackApiCalled: {
          ...state.callBackApiCalled,
          [action.payload.scribeType]: true
        }
      };
    case candidatesActions.SET_COURSE_TAB:
      return {
        ...state,
        courseTabs: action.payload,
      };
    case candidatesActions.SET_MASTER_FIELDS:
      return {
        ...state,
        masterFields: action.payload,
      };
    case candidatesActions.SET_COURSE_ACTIVE_TAB:
      return {
        ...state,
        courseActiveTab: action.payload,
        isActiveTabLoaded: true,
      };
    case candidatesActions.SET_COURSE_APPLICANTID:
      return {
        ...state,
        applicantid: action.payload,
      };
    case candidatesActions.SET_COURSE_STATUS:
      return {
        ...state,
        courseStatus: action.payload,
      };
    case candidatesActions.SET_COURSE_STATUS:
      return {
        ...state,
        courseStatus: action.payload,
      };
    case candidatesActions.SET_IS_PAID:
      return {
        ...state,
        ispaid: action.payload,
      };
    case candidatesActions.SET_PAYMENT_RECEIPT_LIST:
      return {
        ...state,
        paymentReceiptList: action.payload,
      };
    case candidatesActions.SET_EXAM_STATE:
      return {
        ...state,
        examState: action.payload,
      }
    case candidatesActions.SET_EXAM_DISTRICT:
      return {
        ...state,
        examDistrict: action.payload,
      }
    case candidatesActions.SET_EXAM_LANGUAGE:
      return {
        ...state,
        examLanguage: action.payload,
      }
    case candidatesActions.SET_COURSE_FORM_DETAILS:
      return {
        ...state,
        courseFormDetails: action.payload,
      }
    case candidatesActions.SET_CURRENT_COURSE:
      return {
        ...state,
        currentCourseDetails: action.payload,
      }
    case candidatesActions.SET_IP_ADDRESS:
      return {
        ...state,
        ipAddress: action.payload
      }
    case candidatesActions.SET_OTBS_VENUE_DETAILS:
      return {
        ...state,
        otbsVenueDetails: action.payload
      }
    case candidatesActions.SET_CURRENT_VENUE_DETAILS:
      return {
        ...state,
        currentOtbsVenue: action.payload
      }
    case candidatesActions.SET_CANDIDATE_COURSE_DETAILS:
      return {
        ...state,
        getcourseCandidateDetail: action.payload
      }

    case candidatesActions.SET_ELIGIBILITY_DETAILS:
      return {
        ...state,
        getEligibilityDetail: action.payload
      }

    case candidatesActions.SET_ADMITCARD_URL:
      return {
        ...state,
        admitcardurl: action.payload
      }
    case candidatesActions.SET_ADMIT_CARD_DOWNLOAD_DETAILS:
      return {
        ...state,
        admitCardDownloadDetails: action.payload
      }
    case candidatesActions.SET_SCORE_CARD_DOWNLOAD_DETAILS:
      return {
        ...state,
        scoreCardDownloadDetails: action.payload
      }
    case candidatesActions.SET_COURSE_PERSONAL_INFORMATION_DETAILS:
      return {
        ...state,
        coursePersonalInformationDetails: action.payload,
      };

    case candidatesActions.SET_COURSE_RESERVATION_DETAILS:
      return {
        ...state,
        courseReservationDetails: action.payload,
        courseReservationDetailsLoaded: true
      };

    case candidatesActions.SET_COURSE_ACADEMIC_DETAILS:
      return {
        ...state,
        courseAcademicDetails: action.payload,
        courseAcademicDetailsLoaded: true,
      };

    case candidatesActions.SET_COURSE_EXAMCENTER_DETAILS:
      return {
        ...state,
        courseExamCenterDetails: action.payload,
        courseExamCenterDetailsLoaded: true,
      };

    case candidatesActions.SET_COURSE_EDITINGFACILITY_DETAILS:
      return {
        ...state,
        courseEditingFacilityDetails: action.payload,
        isEditingFacilityDetailsLoaded: true,
      };

    case candidatesActions.SET_COURSE_PAYMENTINFORMATION_DETAILS:
      return {
        ...state,
        coursePaymentInformationDetails: action.payload,
        paymentConfirmationLoaded: true
      };
    case candidatesActions.SET_BYPASS_REGISTRATION:
      return {
        ...state,
        bypassRegistrationData: action.payload
      }
    case candidatesActions.SET_AIRPAY_PAYMNET:
      return {
        ...state,
        isAirpay: action.payload,
        ispaymentLoading: true
      }
          case candidatesActions.SET_BILLDESK_PAYMENT:
      return {
        ...state,
        isBilldesk: action.payload,
        isBilldeskpaymentLoading: true
      }
    case candidatesActions.SET_TOTAL_FEE:
      return {
        ...state,
        totalFee: action.payload,
      }



    default:
      return state;
  }
};

export default candidatesReducer;
